import Box, { BoxProps } from "@mui/material/Box";
import { CsiImage, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

const Container = (props: BoxProps) => (
	<Box
		bgcolor="grey.200"
		border={STANDARD_BORDER_STYLE}
		display="inline-block"
		height={75}
		width={100}
		{...props}
	/>
);

export default () => {
	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="no image" />
			<Text semiBold text="custom no image" />
			<Text semiBold text="error" />
			<Text semiBold text="custom error" />
			<Container>
				<CsiImage size="small" />
			</Container>
			<Container>
				<CsiImage noImageComponent={<Text text="No Image" />} size="small" />
			</Container>
			<Container>
				<CsiImage size="small" src="xxx" />
			</Container>
			<Container>
				<CsiImage
					errorComponent={<Text text="ERROR" />}
					size="small"
					src="xxx"
				/>
			</Container>
		</CssColumnGrid>
	);
};